import { useQuery } from '@tanstack/react-query';

import { secretService } from '@/services/secret-service';
import { isEmptyUUID, type UUID } from '@/utils/uuid';

import { secretQueryKeys } from './query-keys';

/**
 * Hook to fetch a specific secret template by ID for a tenant.
 * Returns a react-query query with the secret template details.
 */
export function useFindSecretTemplate(tenantId?: UUID, templateId?: UUID) {
  return useQuery({
    queryKey: secretQueryKeys.templateDetail(tenantId, templateId),
    queryFn: () => {
      if (isEmptyUUID(tenantId)) throw new Error('Missing tenant id');
      if (isEmptyUUID(templateId)) throw new Error('Missing template id');
      return secretService.findSecretTemplate(tenantId!, templateId!);
    },
    enabled: !isEmptyUUID(tenantId) && !isEmptyUUID(templateId),
  });
}
